import React from 'react'
import '../Table.css'
import { TableAdvancedBody } from './TableAdvancedBody'
import { TableAdvancedFooter } from './TableAdvancedFooter'
import { TableAdvancedHead } from './TableAdvancedHead'
import { TableAdvancedHeadTabs } from './TableAdvancedHeadTabs'

const TableAdvanced = ({ checkAll, selectAllItems, unselectAllItems, excluidos,
    incluidos, setExcluidos, setIncluidos, children, classNameTableAdvanced = '' }: any) => {

    function addPropsToReactElement(element: any, props: any) {
        if (React.isValidElement(element)) {
            return React.cloneElement(element, props)
        }
        return element
    }

    return (
        <section className={`TableAdvanced ${classNameTableAdvanced}`}>
            <>
                {
                    children?.map((childElement: any, indexchildElement: any) =>
                        addPropsToReactElement(childElement, { selectAllItems, unselectAllItems, 'key': indexchildElement })
                    )
                }
            </>
        </section>
    )
}

TableAdvanced.Head = TableAdvancedHead;
TableAdvanced.HeadTabs = TableAdvancedHeadTabs;
TableAdvanced.Body = TableAdvancedBody;
TableAdvanced.Footer = TableAdvancedFooter;

export default TableAdvanced;